/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Prefered language.
 */
export enum PreferredLanguage {
  ENGLISH = 'english',
  SPANISH = 'spanish',
}
